const ConditionalRender = ({ condition, children, fallback = null }) => {
    // Si es un array, verificar que tenga elementos
    if (Array.isArray(condition)) {
        return condition.length > 0 ? children : fallback;
    }

    // Para to lo demás, usar la evaluación normal de JavaScript
    return condition ? children : fallback;
};

export default ConditionalRender;